import { useCallback, type KeyboardEvent, type MouseEvent } from "react";
import type { TableRow } from "./TableRow";

// 중첩 인터랙티브 가드는 utils로 이관해 Card 선택적 클릭과 공유한다(단일 source).
import { isNestedInteractiveTarget } from "../../utils/nestedInteractive";

// 기존 import 호환을 위해 re-export 한다.
export { isNestedInteractiveTarget };

// clickable 행/그리드 아이템의 클릭·키보드(Enter/Space) 활성화 핸들러.
// DataTable·DataGridView가 공유해 중복 로직과 드리프트를 막는다.
export function useRowActivation<Row extends TableRow>(): {
  onActivateClick: (event: MouseEvent<HTMLElement>, row: Row) => void;
  onActivateKeyDown: (event: KeyboardEvent<HTMLElement>, row: Row) => void;
} {
  const onActivateClick = useCallback((event: MouseEvent<HTMLElement>, row: Row) => {
    if (!row.isRowClickable || isNestedInteractiveTarget(event.target, event.currentTarget)) {
      return;
    }
    row.onRowClick();
  }, []);

  const onActivateKeyDown = useCallback((event: KeyboardEvent<HTMLElement>, row: Row) => {
    if (!row.isRowClickable || (event.key !== "Enter" && event.key !== " ")) {
      return;
    }
    if (isNestedInteractiveTarget(event.target, event.currentTarget)) {
      return;
    }
    event.preventDefault();
    row.onRowClick();
  }, []);

  return { onActivateClick, onActivateKeyDown };
}
